import React from 'react';

import { MoneyMapperSectionOverrideFooter } from '../MoneyMapperSectionOverrideFooter';
import type { MoneyMapperGuideMonthlyTakeHome } from './useMoneyMapperGuideMonthlyTakeHome';

export interface MonthlyTakehomeFooterProps {
    guideTotal: MoneyMapperGuideMonthlyTakeHome;
    isSaving: boolean;
}

const TAKE_HOME_TITLE = 'Monthly take-home pay';

export const MonthlyTakehomeFooter = ({
    guideTotal,
    isSaving,
}: MonthlyTakehomeFooterProps) => {
    const {
        effectiveMonthlyCents,
        sourcesTotalCents,
        manualDiffersFromSourcesTotal,
        showActualTakeHomeSubline,
        isSavingGuide,
        isEditingGuideTotal,
        guideDraftStr,
        setGuideDraftStr,
        commitGuideTotal,
        removeManualGuideTotal,
        beginGuideInputEdit,
        cancelGuideInputEdit,
    } = guideTotal;

    return (
        <MoneyMapperSectionOverrideFooter
            accentColor="$green500"
            title={TAKE_HOME_TITLE}
            sheetTitle={TAKE_HOME_TITLE}
            effectiveCents={effectiveMonthlyCents}
            sourcesTotalCents={sourcesTotalCents}
            manualOverrideActive={manualDiffersFromSourcesTotal}
            showSourcesSubline={showActualTakeHomeSubline}
            sourcesSublinePrefix="Actual take-home pay:"
            isSaving={isSaving}
            isSavingEdit={isSavingGuide}
            isEditing={isEditingGuideTotal}
            draftStr={guideDraftStr}
            setDraftStr={setGuideDraftStr}
            commitEdit={commitGuideTotal}
            removeManualOverride={removeManualGuideTotal}
            beginEdit={beginGuideInputEdit}
            cancelEdit={cancelGuideInputEdit}
        />
    );
};
